export default __webpack_public_path__ + "static/media/mamut_xl3.234806a2.png";